import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

const CustomDatePicker = ({
  label,
  format = 'MM/dd/yyyy',
  value = new Date(),
  onChange,
}) => (
  <LocalizationProvider dateAdapter={AdapterDateFns}>
    <DatePicker
      label={label}
      format={format}
      value={value}
      onChange={(v) => _.isFunction(onChange) && onChange(v)}
      slotProps={{
        textField: {
          margin: 'normal',
          fullWidth: true,
        },
      }}
    />
  </LocalizationProvider>
);

CustomDatePicker.propTypes = {
  label: PropTypes.string,
  format: PropTypes.string,
  value: PropTypes.instanceOf(Date),
  onChange: PropTypes.func,
};

export default CustomDatePicker;
